import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from 'src/app/shared/forms/dynamic-form/dynamic-form.service';

@Component({
    selector: 'formly-left-text-with-toggle',
    templateUrl: "./formly-left-text-with-toggle.component.html",
    standalone: false
})
export class FormlyLeftTextWithToggleComponent extends FieldType implements OnInit, OnDestroy {
    param: any;
    isFormSubmitted: boolean = false;
    formSubmissionSubscription: Subscription;
    fieldKey: string;
    enableBigToggle = true;
    constructor(private dynamicFormService: DynamicFormService) {
        super();
    }

    ngOnInit() {
        if (this.field.key) {
            this.fieldKey =this.field.id??this.field.key.toString();
        }
        this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
            this.isFormSubmitted = data;
        });
        if (this.to.options && this.to.options[0] && this.to.options[0].enableBigToggle != undefined){
            this.enableBigToggle = this.to.options[0].enableBigToggle;
        }
    }

    ngOnDestroy() {
        if (this.formSubmissionSubscription) {
            this.formSubmissionSubscription.unsubscribe();
        }
    }

    onValueChange() {
        this.to.change(this.field, this.formControl.value);
    }

}